import { defineNuxtPlugin, useNuxtApp, useRequestEvent } from 'nuxt/app';
import { awCookieUniversalFactory } from 'awServerModule/runtime/util/awCookies';

function createPluginProvides () {
  const nuxtApp = useNuxtApp();
  const event = useRequestEvent(nuxtApp);
  const { auchanApiBrowserHost } = nuxtApp.$awRuntimeConfig;
  const cookiesPlugin = awCookieUniversalFactory({
    req: event?.node?.req,
    res: event?.node?.res,
    awIsSecureByDefault: auchanApiBrowserHost.startsWith('https'),
    parseJSON: true,
  });
  // TODO: For compat reasons cookiesPlugin is injected as '$cookies'. May
  // want to add an 'aw' prefix in the future.
  return {
    cookies: cookiesPlugin,
  };
}

export type AwCookiesPluginProvides = ReturnType<typeof createPluginProvides>;

export default defineNuxtPlugin(() => {
  return {
    provide: createPluginProvides(),
  };
});
